import "./Mcq.css";
import { useState, useEffect, useRef } from "react";
import {
  Radio,
  Button,
  Card,
  notification,
  Input,
  Checkbox,
  Progress,
  Space,
} from "antd";
import { useNavigate, useParams } from "react-router";
import { useStateValue } from "../../../../../Reducer/reducer";
import QuizIcon from "@mui/icons-material/Quiz";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import { AssesmentUrl, BaseUrl } from "../../../../Constants/Constants";
import Swal from "sweetalert2";
import { actionTypes } from "../../../../../Reducer/StateProvider";
import { useLocation } from "react-router";
import { message } from "antd";

const CareerMcq = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { assessment_name, duration, no_of_questions } = location.state || {};

  const [{ UserID, Questions }, dispatch] = useStateValue();

  // console.log(Questions,"questions")

  const [questions, setQuestions] = useState(Questions);

  const [api, contextHolder] = notification.useNotification();
  const [mcq_id, setmcq_id] = useState("");

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [timer, setTimer] = useState(1200); // 10 minutes in seconds
  const [BookmarkStatus, setBookmarkStatus] = useState(false);
  const history = useNavigate();
  const [Selected, setSelected] = useState("");
  const [UserResponses, setUserResponses] = useState([]);
  const [SelectedQuestionId, setSelectedQuestionId] = useState("");


  const [selectedAnswers, setSelectedAnswers] = useState({});

  const [viewedStatus, setViewedStatus] = useState(
    Array(questions.length).fill(false)
  );
  const [status, setStatus] = useState(
    new Array(questions.length).fill("unanswered")
  );
  const [questionColors, setQuestionColors] = useState(
    new Array(questions.length).fill("transparent")
  );
  const [initialized, setInitialized] = useState(false);

  const { id } = useParams();
  const { assessmentId,groupId } = useParams();

  const cleanedString = assessmentId.replace(/\s+/g, " ");
  let modUrl = cleanedString.toLowerCase().split(" ");
  let url = modUrl.join("-");
  let structuredUrl = url.split("/").join("-");

  const questionChart = questions.map((_, index) => index + 1);
  const rowsOfNumbers = [];
  for (let i = 0; i < questionChart.length; i += 5) {
    rowsOfNumbers.push(questionChart.slice(i, i + 5));
  }
  // console.log(timer, 'timerDetails')
const autoSubmittedRef = useRef(false);
  const tabSwitchCountRef = useRef(0);
  const userResponsesRef = useRef([]);
  const violationLockRef = useRef(false);

useEffect(() => {
  userResponsesRef.current = UserResponses;
}, [UserResponses]);


  useEffect(() => {
    if (duration) {
      setTimer(Number(duration) * 60);
    }
  }, [duration]);

  const formatQuestion = (question) => {
    if (!question) return "";

    let formattedQuestion = question.replace(/\\n\s*([a-zA-Z])\./g, "<br/>$1.");

    formattedQuestion = formattedQuestion.replace(
      /(?:^|\s)([a-z])\./g,
      (match, p1) => {
        return match.replace(p1, p1.toUpperCase());
      }
    );
    formattedQuestion = formattedQuestion.replace(
      /\\n(?!\s*[a-zA-Z]\.)/g,
      "<br/>"
    );
    formattedQuestion = formattedQuestion.replace(/\s*<br\/>\s*/g, "<br/>");
    return formattedQuestion;
  };



  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const handleOptionSelect = (e, questionId) => {
    const selectedOption = e.target.value;
    setSelectedOption(selectedOption);

    const updatedResponses = [...UserResponses];
    const existingResponseIndex = updatedResponses.findIndex(
      (response) => response?.question_id === questionId
    );

    if (existingResponseIndex !== -1) {
      updatedResponses[existingResponseIndex] = {
        question_id: questionId,
        answer: selectedOption,
      };
    } else {
      updatedResponses.push({
        question_id: questionId,
        answer: selectedOption,
      });
    }

    setUserResponses(updatedResponses);

    const updatedStatus = [...status];
    updatedStatus[currentQuestion] = "answered";
    setStatus(updatedStatus);

    const updatedColors = [...questionColors];
    updatedColors[currentQuestion] = "green";
    setQuestionColors(updatedColors);
  };

  console.log("channnn", UserResponses);
  // console.log(selectedOption, "selected")

  const openNotificationWithIconWarning = (type) => {
    api["warning"]({
      message: "Warning!!!",
      description: type,
    });
  };

  const openAlert = (type) => {
    Swal.fire({
      title: "Alert!!!",
      text: type,
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/career-program/group/${groupId}/course/${id}`);
      }
    });
  };

  useEffect(() => {
    if (UserResponses.length > 0 && questions[currentQuestion]) {
      const currentQuestionId = questions[currentQuestion]?.question_id;
      const existingResponse = UserResponses.find(
        (response) => response?.question_id === currentQuestionId
      );

      if (existingResponse) {
        setSelectedOption(existingResponse.answer);
      } else {
        setSelectedOption(null);
      }
    }
  }, [currentQuestion, questions, UserResponses]);

  const handleNextQuestion = () => {
    handleLeavingQuestion(); // This will check if the current question is unanswered and mark it accordingly

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
      setSelectedOption(UserResponses[currentQuestion + 1]?.answer || null);
    }
  };

  const handlePreviousQuestion = () => {
    handleLeavingQuestion();
    if (currentQuestion > 0) {
      setCurrentQuestion((prev) => prev - 1);
      setSelectedOption(UserResponses[currentQuestion - 1]?.answer || null);
    }
  };

  const handleAnswerQuestion = () => {
    const updatedStatus = [...status];
    updatedStatus[currentQuestion] = "answered";
    setStatus(updatedStatus);

    const updatedColors = [...questionColors];
    updatedColors[currentQuestion] = "green";
    setQuestionColors(updatedColors);
  };

  const allQuestionsAnswered = (questions, responses) => {
    return questions.every((q) => {
      const res = responses.find((r) => r?.question_id === q?.question_id);
      if (!res || res.answer == null) return false;
      if (Array.isArray(res.answer)) return res.answer.length > 0;
      if (typeof res.answer === "string") return res.answer.trim() !== "";
      return false;
    });
  };

  const showAttemptMessage = (attempt, maxAttempts = 3) => {
    const remaining = maxAttempts - attempt;

    if (remaining > 1) {
      message.warning(
        `This was your ${attempt}${attempt === 1 ? "st" : "nd"} attempt. 
You have ${remaining} more attempts remaining.`,
        8
      );
    } else if (remaining === 1) {
      message.warning(
        "This was your second attempt. You have only ONE LAST chance to clear this assessment.",
        8
      );
    } else {
      message.error(
        "You have failed all attempts for this assessment. Please contact your course manager.",
        8
      );
    }
  };

  // Key changes in handleFinish function

  const handleFinish = () => {
    const updatedResponses = [...UserResponses];
    const currentQuestionId = questions[currentQuestion]?.question_id;

    const existingIndex = updatedResponses.findIndex(
      (resp) => resp?.question_id === currentQuestionId
    );

    if (existingIndex !== -1) {
      updatedResponses[existingIndex].answer = selectedOption;
    } else {
      updatedResponses.push({
        question_id: currentQuestionId,
        answer: selectedOption,
      });
    }

    const allAnswered = allQuestionsAnswered(questions, updatedResponses);

    if (allAnswered) {
      setAssessmentCompleted(true);

      const body = {
        course_id: id,
        user_id: UserID,
        user_answer: UserResponses.map((item) => ({
          question_id: item.question_id,
          answer: item.answer,
        })),
        assessment_id: assessmentId,
        group_id:groupId,
      };

      axios
        .post(`${AssesmentUrl}career_dev_QA_validation`, body)
        .then((res) => {
          console.log(res, "response");
          closeFullscreen();

          // ✅ PARSE SCORE FROM RESPONSE
          const responseData = res?.data;
          let userScore = 0;
          let totalScore = 0;

          if (responseData?.score) {
            const scoreParts = responseData.score.split("/");
            userScore = parseInt(scoreParts[0]) || 0;
            totalScore = parseInt(scoreParts[1]) || 0;
          }

          console.log("Parsed Scores:", { userScore, totalScore }); // Debug log

          // Calculate eligibility based on score
          const eligibilityPercentage = (userScore / totalScore) * 100;
          const isEligible = eligibilityPercentage >= 50 ? "Pass" : "Fail";
          const attempt = responseData?.assessment_attempt_count || 1;

          dispatch({
            type: actionTypes.SET_Eligibility,
            eligibility: isEligible,
          });
          localStorage.setItem("course_eligibility", isEligible);

          if (isEligible === "Pass") {
            message.success("You have Successfully completed the course", 6);
          } else {
            showAttemptMessage(attempt);
          }

          // ✅ NAVIGATE TO RESULT PAGE WITH SCORES IN STATE
          history(
            `/career-program/group/${groupId}/course/${id}/assessment/${assessmentId}/mcq/result`,
            {
              state: { userScore, totalScore },
            }
          );
        })
        .catch((err) => {
          console.log(err);
          message.error("Failed to submit assessment");
        });
    } else {
      openNotificationWithIconWarning("Select at least one option");
    }
  };

  const HandleSlected = (e) => {
    let selectedNum = questions.find((i) => i.id == parseInt(e));
    // questions.push()
    console.log(e, "clicked", selectedNum);
  };
  const handleQuestionClick = (questionIndex, selectedOption) => {
    const isCorrect = questions[questionIndex].correctAnswer === selectedOption;
    const updatedStatus = [...status];
    updatedStatus[questionIndex] = isCorrect ? "correct" : "incorrect";
    setStatus(updatedStatus);
  };
  const HandleSelected = (questionId) => {
    setCurrentQuestion(questionId - 1);

    const updatedColors = [...questionColors];
    updatedColors[questionId - 1] = selectedOption ? "answered" : "unanswered";
    setQuestionColors(updatedColors);
  };
  const handleSelectedQuestion = (questionId) => {
    handleLeavingQuestion();
    const questionIndex = questionId - 1;
    setCurrentQuestion(questionIndex);
    setSelectedOption(UserResponses[questionIndex]?.answer || null);
  };
  const HandleBookmark = (e) => {
    const isBookmarked = e === currentQuestion - 1;
    setBookmarkStatus(isBookmarked);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // You can perform actions here before the page is unloaded/reloaded
      console.log("Page is about to be reloaded");

      // Optionally, you can show a confirmation message
      const confirmationMessage = "Are you sure you want to leave?";
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      // Cleanup the event listener when the component unmounts
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [assessmentCompleted, setAssessmentCompleted] = useState(false);

  const openFullscreen = () => {
    const doc = document.documentElement;
    if (doc.mozRequestFullScreen) {
      // Firefox
      doc.mozRequestFullScreen();
    } else if (doc.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      doc.webkitRequestFullscreen();
    } else if (doc.msRequestFullscreen) {
      // IE/Edge
      doc.msRequestFullscreen();
    }
    setIsFullScreen(true);
  };

  const closeFullscreen = () => {
    if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleSelectedAns = (value) => {
    if (!questions[currentQuestion]) return;
    setSelectedOption(value);

    const updatedResponses = [...UserResponses];
    updatedResponses[currentQuestion] = {
      question_id: questions[currentQuestion]?.question_id,
      answer: value,
    };
    setUserResponses(updatedResponses);

    // ✅ Mark question as answered
    const updatedStatus = [...status];
    updatedStatus[currentQuestion] = "answered";
    setStatus(updatedStatus);

    // ✅ Set color to green
    const updatedColors = [...questionColors];
    updatedColors[currentQuestion] = "green";
    setQuestionColors(updatedColors);
  };

  useEffect(() => {
    if (UserResponses.length > 0) {
      const currentQuestionId = questions[currentQuestion]?.question_id;
      const existingResponse = UserResponses.find(
        (response) => response?.question_id === currentQuestionId
      );

      if (existingResponse) {
        setSelectedOption(existingResponse.answer);
      } else {
        setSelectedOption(null);
      }
    }
  }, [currentQuestion, questions]);

  useEffect(() => {
    if (
      viewedStatus[currentQuestion] &&
      status[currentQuestion] === "unanswered"
    ) {
      const updatedStatus = [...status];
      updatedStatus[currentQuestion] = "viewed-unanswered";
      setStatus(updatedStatus);
    }
  }, [currentQuestion]);


  const markQuestionAsViewed = (questionIndex) => {
    if (
      status[questionIndex] === "unanswered" &&
      !viewedStatus[questionIndex]
    ) {
      const updatedViewedStatus = [...viewedStatus];
      updatedViewedStatus[questionIndex] = true;
      setViewedStatus(updatedViewedStatus);
    }
  };
  const handleLeavingQuestion = () => {
    const currentQ = currentQuestion;

    // Only update if the question is unanswered and viewed
    if (status[currentQ] === "unanswered" && selectedOption === null) {
      const updatedStatus = [...status];
      updatedStatus[currentQ] = "viewed-unanswered";
      setStatus(updatedStatus);

      const updatedColors = [...questionColors];
      updatedColors[currentQ] = "red"; // Set color to red
      setQuestionColors(updatedColors);
    }
  };

  useEffect(() => {
    // Check if transitioning from the first question
    if (currentQuestion > 0 && currentQuestion < questions.length) {
      const previousQuestion = 0;
      const updatedStatus = [...status];
      const updatedColors = [...questionColors];

      // Mark the previous question as viewed and unanswered if it was not answered
      if (
        status[previousQuestion] === "unanswered" &&
        selectedOption === null
      ) {
        updatedStatus[previousQuestion] = "viewed-unanswered";
        updatedColors[previousQuestion] = "red"; // Set color to red
      }

      // Update the status and color for the current question
      // Initialize the current question status as 'unanswered'

      // Set the updated status and colors
      setStatus(updatedStatus);
      setQuestionColors(updatedColors);

      // Mark the current question as viewed
      setViewedStatus((prevViewedStatus) => {
        const newViewedStatus = [...prevViewedStatus];
        newViewedStatus[currentQuestion] = true;
        return newViewedStatus;
      });
    }
  }, [currentQuestion, status, selectedOption]);

  console.log("Current Question:", currentQuestion);
  console.log("Status:", status);
  console.log("Question Colors:", questionColors);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    .questionParagraphinmcq img {
      max-width: 100%;
      height: 400px;
      display: block;
      margin: 10px 0;
    }
  `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);


 useEffect(() => {
  if (assessmentCompleted) return;

  const countdown = setInterval(() => {
    setTimer((prevTimer) => {
      if (prevTimer <= 1) {
        clearInterval(countdown);

        handleAutoSubmit("TIME_UP"); // ✅ no flag here

        return 0;
      }
      return prevTimer - 1;
    });
  }, 1000);

  return () => clearInterval(countdown);
}, [assessmentCompleted]);



const handleAutoSubmit = (reason = "TIME_UP") => {
  if (autoSubmittedRef.current) return;
  autoSubmittedRef.current = true; // ✅ ONLY PLACE

  const messageText =
    reason === "TAB_SWITCH"
      ? "Assessment auto-submitted due to tab switching."
      : "Time is up! Submitting your assessment automatically...";

  message.warning(messageText, 4);

  const answers = userResponsesRef.current;

  const body = {
    course_id: id,
    user_id: UserID,
    assessment_id: assessmentId,
    group_id: groupId,
    auto_submit_reason: reason,
    user_answer: answers.map((item) => ({
      question_id: item.question_id,
      answer: item.answer,
    })),
  };

  axios
    .post(`${AssesmentUrl}career_dev_QA_validation`, body)
    .then((res) => {
      closeFullscreen();
      setAssessmentCompleted(true);

      let userScore = 0;
      let totalScore = 0;
      if (res?.data?.score) {
        const [s, t] = res.data.score.split("/");
        userScore = Number(s) || 0;
        totalScore = Number(t) || 0;
      }

      history(
        `/career-program/group/${groupId}/course/${id}/assessment/${assessmentId}/mcq/result`,
        {
          state: { userScore, totalScore, reason },
        }
      );
    })
    .catch(() => {
      message.error("Auto submission failed. Please contact support.");
    });
};



useEffect(() => {
  const handleVisibilityChange = () => {
    if (
      assessmentCompleted ||
      autoSubmittedRef.current ||
      violationLockRef.current
    ) {
      return;
    }

    if (document.hidden) {
      violationLockRef.current = true;

      tabSwitchCountRef.current += 1;

      if (tabSwitchCountRef.current === 1) {
        message.warning(
          "⚠️ Warning: Switching tabs, minimizing, or changing apps is not allowed.",
          4
        );
      } else {
        message.error(
          "Assessment auto-submitted due to multiple tab switches.",
          5
        );

        handleAutoSubmit("TAB_SWITCH");
      }

      // Unlock after browser settles
      setTimeout(() => {
        violationLockRef.current = false;
      }, 800);
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}, [assessmentCompleted]);


  return (
    <div className="mcqMainDiv">
      {contextHolder}
      {currentQuestion < questions.length ? (
        <div className="mcqContainer">
          {/* Left Side - Question Card */}
          <div className="mcqQuestionSection">
            <Card className="mcqQuestionCard">
              {/* Question Header */}
              <div className="mcqQuestionHeader">
                <div className="mcqQuestionHeaderLeft">
                  <div className="mcqQuestionNumberBadge">
                    <QuizIcon className="mcqQuestionIcon" />
                    <span className="mcqQuestionNumber">
                      Question {currentQuestion + 1} of {questions.length}
                    </span>
                  </div>
                </div>
                <div className="mcqTimerBadge">
                  <AccessTimeIcon className="mcqTimerIcon" />
                  <span className="mcqTimerText">{formatTime(timer)}</span>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="mcqProgressBar">
                <Progress
                  percent={((currentQuestion + 1) / questions.length) * 100}
                  showInfo={false}
                  strokeColor={{
                    "0%": "#667eea",
                    "100%": "#764ba2",
                  }}
                  strokeWidth={8}
                />
              </div>

              {/* Question Content */}
              <div className="mcqQuestionContent">
                <div
                  className="mcqQuestionText"
                  dangerouslySetInnerHTML={{
                    __html: formatQuestion(
                      questions[currentQuestion]?.question
                    ),
                  }}
                />

                {/* Answer Options */}
                <div className="mcqOptionsContainer">
                  {questions[currentQuestion]?.options?.every(
                    (opt) => opt === null
                  ) ? (
                    <Input
                      placeholder="Enter your answer"
                      value={selectedOption || ""}
                      onChange={(e) => handleSelectedAns(e.target.value)}
                      className="mcqTextInput"
                      size="large"
                    />
                  ) : questions[currentQuestion]?.question_type === "ma_mcq" ? (
                    <Checkbox.Group
                      value={selectedOption || []}
                      onChange={(checkedValues) =>
                        handleSelectedAns(checkedValues)
                      }
                      className="mcqCheckboxGroup"
                    >
                      <Space
                        direction="vertical"
                        size="middle"
                        style={{ width: "100%" }}
                      >
                        {questions[currentQuestion]?.options?.map(
                          (option, index) =>
                            option !== null ? (
                              <div
                                key={index}
                                className="mcqOptionItem checkboxOption"
                              >
                                <Checkbox
                                  value={option}
                                  className="mcqCheckbox"
                                >
                                  <span className="mcqOptionText">
                                    {option}
                                  </span>
                                </Checkbox>
                              </div>
                            ) : null
                        )}
                      </Space>
                    </Checkbox.Group>
                  ) : (
                    <Radio.Group
                      onChange={(e) =>
                        handleOptionSelect(
                          e,
                          questions[currentQuestion]?.question_id
                        )
                      }
                      value={selectedOption}
                      className="mcqRadioGroup"
                    >
                      <Space
                        direction="vertical"
                        size="middle"
                        style={{ width: "100%" }}
                      >
                        {questions[currentQuestion]?.options?.map(
                          (option, index) =>
                            option !== null ? (
                              <div
                                key={index}
                                className="mcqOptionItem radioOption"
                                onClick={() => handleSelectedAns(option)}
                              >
                                <Radio value={option} className="mcqRadio">
                                  <span className="mcqOptionText">
                                    {option}
                                  </span>
                                </Radio>
                              </div>
                            ) : null
                        )}
                      </Space>
                    </Radio.Group>
                  )}
                </div>
              </div>

              {/* Navigation Buttons */}
              <div className="mcqNavigationButtons">
                {currentQuestion > 0 && (
                  <Button
                    type="default"
                    onClick={handlePreviousQuestion}
                    className="mcqNavButton prevButton"
                    icon={<ArrowBackIcon />}
                    size="large"
                  >
                    Previous
                  </Button>
                )}
                {currentQuestion !== questions.length - 1 ? (
                  <Button
                    type="primary"
                    onClick={handleNextQuestion}
                    className="mcqNavButton nextButton"
                    icon={<ArrowForwardIcon />}
                    size="large"
                  >
                    Next Question
                  </Button>
                ) : (
                  allQuestionsAnswered(questions, UserResponses) && (
                    <Button
                      type="primary"
                      onClick={handleFinish}
                      className="mcqNavButton finishButton"
                      icon={<CheckCircleIcon />}
                      size="large"
                    >
                      Submit Assessment
                    </Button>
                  )
                )}
              </div>
            </Card>
          </div>

          {/* Right Side - Question Chart & Timer */}
          <div className="mcqSidebarSection">
            <Card className="mcqSidebarCard">
              <div className="mcqSidebarHeader">
                <QuizIcon className="mcqSidebarIcon" />
                <h3 className="mcqSidebarTitle">Question Navigator</h3>
              </div>

              <div className="mcqQuestionChart">
                {[...Array(Math.ceil(questions.length / 5)).keys()].map(
                  (rowIndex) => (
                    <div key={rowIndex} className="mcqQuestionChartRow">
                      {questions
                        .slice(rowIndex * 5, rowIndex * 5 + 5)
                        .map((_, index) => {
                          const questionId = rowIndex * 5 + index + 1;
                          const questionIndex = questionId - 1;
                          const isAnswered =
                            status[questionIndex] === "answered";
                          const isViewedUnanswered =
                            status[questionIndex] === "viewed-unanswered";
                          const isSelected = currentQuestion === questionIndex;

                          return (
                            <div
                              key={questionId}
                              onClick={() => handleSelectedQuestion(questionId)}
                              className={`mcqQuestionNumberItem ${
                                isSelected ? "selected" : ""
                              } ${
                                isAnswered
                                  ? "answered"
                                  : isViewedUnanswered
                                  ? "viewedUnanswered"
                                  : "unanswered"
                              }`}
                            >
                              {questionId}
                            </div>
                          );
                        })}
                    </div>
                  )
                )}
              </div>

              <div className="mcqLegend">
                <div className="mcqLegendItem">
                  <div className="mcqLegendColor answered"></div>
                  <span>Answered</span>
                </div>
                <div className="mcqLegendItem">
                  <div className="mcqLegendColor viewedUnanswered"></div>
                  <span>Not Answered</span>
                </div>
                <div className="mcqLegendItem">
                  <div className="mcqLegendColor unanswered"></div>
                  <span>Not Visited</span>
                </div>
              </div>

              <div className="mcqTimerCard">
                <div className="mcqTimerContent">
                  <AccessTimeIcon className="mcqTimerLargeIcon" />
                  <div className="mcqTimerInfo">
                    <span className="mcqTimerLabel">Time Remaining</span>
                    <span className="mcqTimerValue">{formatTime(timer)}</span>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      ) : (
        <div className="mcqNoQuestions">
          <h3>No Questions Available</h3>
        </div>
      )}
    </div>
  );
};

export default CareerMcq;
